const tags = {
  all: ['child_care_room', 'room_for_stroller'],
  activity: ['free'],
  events: [],
  restaurant: ['brunch', 'kids_menu', 'playroom'],
  service: [],
};

export default tags;
